/* eslint-disable @typescript-eslint/ban-ts-comment */
// @ts-ignore
'hasOwn' in Object || (Object.hasOwn = Object.call.bind(Object.hasOwnProperty));
